var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0645 3.86603C10.9927 3.33013 12.1362 3.33013 13.0645 3.86603L17.8587 6.63397C18.7869 7.16987 19.3587 8.16025 19.3587 9.23205V14.7679C19.3587 15.8397 18.7869 16.8301 17.8587 17.366L13.0645 20.134C12.1363 20.6699 10.9927 20.6699 10.0645 20.134L5.27022 17.366C4.34202 16.8301 3.77022 15.8397 3.77022 14.7679V9.23205C3.77022 8.16025 4.34202 7.16987 5.27022 6.63397L10.0645 3.86603Z",
    stroke: "#6B7280",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6984 5.5C11.0833 4.83333 12.0456 4.83333 12.4305 5.5L17.6266 14.5C18.0115 15.1667 17.5304 16 16.7606 16H6.3683C5.5985 16 5.11738 15.1667 5.50228 14.5L10.6984 5.5Z",
    stroke: "#6B7280",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIconDark);
export default __webpack_public_path__ + "static/media/graphIconDark.7bfb0b673236f583aa3934514e944ebb.svg";
export { ForwardRef as ReactComponent };